import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuinfouiComponent } from './menuinfo-ui.component';
import { InlineSVGModule } from 'ng-inline-svg';



@NgModule({
  declarations: [MenuinfouiComponent],
  imports: [
    CommonModule,
    InlineSVGModule
  ],
  exports:[MenuinfouiComponent]
})
export class MenuinfouiModule { }
